import Highcharts from 'highcharts';

export default
{
    legend: {
        layout: 'horizontal', align:'center', verticalAlign: 'bottom'

    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'column',
        animation: true,
        height: '350px',
    },
    title: false,
    subtitle: {
        text: null
    },
    xAxis: {
        gridLineWidth: 1,
        gridLineColor: 'rgba(100,100,100,0.1)',
        lineColor: '#000',
        lineWidth: 1,
        tickColor: '#000',
        categories: [],

        minorGridLineColor: 'rgba(100,100,100,0.05)',

        title: {
            text: 'Nadmorská výška [m] / UV Index'
        },

        labels: {
            rotation: 0,
            y:15,
            format: '{value}m'
        },
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,

    },
    yAxis: [{
        min: 0,
        opposite: true,
        max: 11,
        title: {
            text: 'UV Index',
            enabled:false
        },
        minorTickInterval: 0.5,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(100,100,100,0.05)',
        gridLineColor: 'rgba(100,100,100,0.1)',

        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        tickInterval: 1,
        tickColor: '#000',
        plotLines:[
            { color: '#129936', width: 2, value: 2},
            { color: '#f0ff00', width: 2, value: 5},
            { color: '#FF8C00', width: 2, value: 7},
            { color: '#b10808', width: 2, value: 10}
        ],        /*
        plotBands:[
            { color: 'rgba(18,153,54,0.7)', from:0, to: 2},
            { color: 'rgba(240,255,0,0.7)', from: 2, to: 5},
            { color: 'rgba(255,140,0,0.7)', from: 5, to: 8},
            { color: 'rgba(177,8,8,0.7)', from: 8, to: 70},
        ],

         */

    },{
        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        minorTickInterval: 0.5,
        minorGridLineWidth:1,
        tickColor: '#000',
        title: null,
        labels: {

            enabled: true
        },
    }],
    tooltip: {
        headerFormat: '<span style="font-size: 10px">Nadmorská výška: {point.key}m</span><br>',
        enabled: true,

    },
    plotOptions: {
        column: {
            borderWidth:1,
            borderColor: 'rgba(0,0,0,1)',
            /*
            dataLabels: {
                enabled: true,
                rotation: -90,
                color: '#FFFFFF',
                align: 'right',
                format: '{point.y:.1f}', // one decimal
                y: 3, // 10 pixels down from the top
                style: {
                    fontWeight: 'normal',
                    fontSize: '7px',
                    fontFamily: 'Verdana, sans-serif'
                }
            },
             */
            /*
                        zones: [{
                            value: 5,
                            color: '#129936'
                        }, {
                            value: 7,
                            color: '#f0ff00'
                        }, {
                            color: '#b10808'
                        }]
            */

        },
        states:{
            hover:{
                enabled:false,
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [
        {id:'uvz-jasno', name:'Jasno', showInLegend: true, lineWidth:1, data:[],
            color:'rgba(0,0,0,0.5)',
            zones: [{
                value: 2,
                color: '#129936'
            }, {
                value: 5,
                color: '#f0ff00'
            }, {
                value: 7,
                color: '#FF8C00'
            }, {
                color: '#b10808'
            }],
        },
        {id:'uvz-polooblacno', name:'Polooblačno', showInLegend: true,  data:[],
            zones: [{
                value: 2,
                //color: '#129936'
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 5 L 5 0 M -1 1 L 1 -1 M 4 6 L 6 4',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)',
                        },
                        backgroundColor: '#129936',
                        width: 5,
                        height: 5,
                    }
                },
            }, {
                value: 5,
                //color: '#f0ff00'
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 5 L 5 0 M -1 1 L 1 -1 M 4 6 L 6 4',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)'
                        },
                        backgroundColor: '#f0ff00',
                        width: 5,
                        height: 5,
                    }
                },
            }, {
                value: 7,
                //color: '#f0ff00'
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 5 L 5 0 M -1 1 L 1 -1 M 4 6 L 6 4',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)'
                        },
                        backgroundColor: '#FF8C00',
                        width: 5,
                        height: 5,
                    }
                },
            }, {
                //color: '#b10808'
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 5 L 5 0 M -1 1 L 1 -1 M 4 6 L 6 4',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)'
                        },
                        backgroundColor: '#b10808',
                        width: 5,
                        height: 5,
                    }
                },
            }],

            color: {
                pattern: {
                    path: {
                        d: 'M 0 5 L 5 0 M -1 1 L 1 -1 M 4 6 L 6 4',
                        strokeWidth: 2,
                        stroke: 'rgba(0,0,0,0.5)'
                    },
                    width: 5,
                    height: 5,
                    //color: '#ff0000'
                }
            },

        },
        {id:'uvz-oblacno', name:'Oblačno', showInLegend: true, lineWidth:1, data:[],
            zones: [{
                value: 2,
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 0 L 1 0 L 1 1 L 0 1 L 0 0 Z',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)'
                        },
                        backgroundColor: '#129936',
                        width: 3,
                        height: 3,
                    }
                },
            }, {
                value: 5,
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 0 L 1 0 L 1 1 L 0 1 L 0 0 Z',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)'
                        },
                        backgroundColor: '#FF8C00',
                        width: 3,
                        height: 3,
                    }
                },
                //color: '#FF8C00'
            }, {
                value: 7,
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 0 L 1 0 L 1 1 L 0 1 L 0 0 Z',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)'
                        },
                        backgroundColor: '#f0ff00',
                        width: 3,
                        height: 3,
                    }
                },
                //color: '#f0ff00'
            }, {
                color: {
                    pattern: {
                        path: {
                            d: 'M 0 0 L 1 0 L 1 1 L 0 1 L 0 0 Z',
                            strokeWidth: 1,
                            stroke: 'rgba(0,0,0,0.5)'
                        },
                        backgroundColor: '#b10808',
                        width: 3,
                        height: 3,
                    }
                },
                //color: '#b10808'
            }],


            color: {
                pattern: {
                    path: {
                        d: 'M 0 0 L 1 0 L 1 1 L 0 1 L 0 0 Z',
                        strokeWidth: 1,
                        stroke: 'rgba(0,0,0,0.5)'
                    },
                    width: 3,
                    height: 3,
                    //color: '#ff0000'
                }
            },


        },
    ]
}
